export var extractPostcodeAndSuburb = function extractPostcodeAndSuburb(location) {
  return {
    postcode: location.replace(/^\D+/g, ""),
    suburb: location.replace(/[^a-zA-Z/\s]+/g, "")
  };
};
export var transformLocationDataRow = function transformLocationDataRow(rawDataRow) {
  return {
    value: rawDataRow.id,
    title: "".concat(rawDataRow.suburb.toLowerCase(), ", ").concat(rawDataRow.postcode)
  };
};
export var transformLocationDataArray = function transformLocationDataArray(rawDataArray) {
  return rawDataArray.map(function (rawDataRow) {
    return transformLocationDataRow(rawDataRow);
  });
};
export * from "./analytics";